module.exports = __webpack_public_path__ + "img/EVENT.dbef2dd0.svg";